import React from "react";
import "./joinourtalentcommunity.css";
import { Users, Briefcase, Building2 } from "lucide-react";

const JoinTalentCommunity = () => {
  return (
    <section className="talent-section">
      <div className="talent-container">
        <div className="talent-header">
          <Users size={48} color="#b76e79" />
          <h1>Join Our Talent Community</h1>
          <p>
            EAEC presently employs a small core team of professionals with a combined
            total of 50+ years of experience and collaborates with over 120 experts
            across Real Estate, Finance, Construction, and Legal industries in Nigeria.
            Our head office is in Gudu, Abuja.
          </p>
        </div>

        <div className="talent-content">
          <div className="talent-card">
            <Briefcase className="talent-icon" />
            <h2>Elevate Your Career</h2>
            <p>
              We elevate the real estate experience for agents too. Join our team and
              receive training and support to become a professional broker.
            </p>
          </div>

          <div className="talent-card">
            <Building2 className="talent-icon" />
            <h2>Be Part of a Recognized Brand</h2>
            <p>
              E.A. Ekanem Consulting’s brand represents professionalism, style, and
              exceptional service. Joining us enhances your credibility and creates
              opportunities for greater success.
            </p>
          </div>

          <div className="talent-card">
            <Users className="talent-icon" />
            <h2>Grow with a Winning Team</h2>
            <p>
              Take your business to the next level with more opportunities and more wins.
              Learn how the power of our brand can help you thrive as an agent or broker.
            </p>
          </div>
        </div>

        <div className="talent-footer">
          <h3>
            Ready to take your career further?
          </h3>
          <p>
            Explore how we help agents and professionals grow — reach out to us to learn how
            to become a brokerage affiliate.
          </p>
          <a href="https://eaekanemconsulting.fillout.com/t/cHFwV4e4gHus" className="join-btn">Join Us Now</a>
        </div>
      </div>
    </section>
  );
};

export default JoinTalentCommunity;
